import { motion } from "framer-motion";
import { Camera } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { GALLERY } from "../data/clinic";

export const Gallery = () => (
  <section
    id="gallery"
    data-testid="gallery-section"
    className="py-24 sm:py-32 bg-sa-beige/50"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
        <div>
          <Reveal>
            <SectionLabel testId="gallery-label">The space</SectionLabel>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-sa-espresso mt-6">
              Inside
              <span className="italic text-sa-bronze"> MS Pet Hospital</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <span
            data-testid="gallery-coming-soon"
            className="inline-flex items-center gap-2 rounded-full bg-sa-cream px-4 py-2 font-body text-sm text-sa-mocha border border-sa-espresso/5"
          >
            <Camera className="w-4 h-4 text-sa-bronze" />
            More photos coming soon
          </span>
        </Reveal>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[220px] sm:auto-rows-[260px]">
        {GALLERY.map((img, i) => (
          <Reveal
            key={i}
            delay={i * 0.1}
            className={i === 0 ? "col-span-2 row-span-2" : "col-span-2 md:col-span-1 lg:col-span-1"}
          >
            <motion.div
              whileHover={{ scale: 0.985 }}
              transition={{ duration: 0.4 }}
              className="group relative h-full w-full rounded-3xl overflow-hidden"
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={img.url}
                alt={img.alt}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-sa-espresso/10 group-hover:bg-sa-espresso/0 transition-colors duration-500" />
            </motion.div>
          </Reveal>
        ))}

        {/* Coming soon tile */}
        <Reveal delay={0.3} className="col-span-2 md:col-span-2">
          <div
            data-testid="gallery-placeholder-tile"
            className="h-full w-full rounded-3xl border-2 border-dashed border-sa-espresso/15 flex flex-col items-center justify-center text-center px-4"
          >
            <Camera className="w-8 h-8 text-sa-bronze/60 mb-3" />
            <p className="font-display text-xl text-sa-espresso">More photos</p>
            <p className="font-body text-sm text-sa-mocha">coming soon</p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Gallery;
